<template>
  <div
    class="offer-card"
    :style="[
      { '--title-color': card.titleColor },
      { '--description-color': card.descriptionColor },
      { '--link-color': card.buttonLabelColor },
      { '--link-border-color': card.buttonBorderColor },
      { '--link-bg': card.buttonBackgroundColor },
      {
        '--bg': `url('${normalizeStrapiUrl(card.backgroundImage.url)}')`,
      },
    ]"
  >
    <div class="offer-card__wrp">
      <div class="offer-card__content">
        <div class="offer-card__txt-wrp">
          <h4 class="offer-card__title">
            {{ card.title }}
          </h4>
          <p class="offer-card__description">
            {{ card.description }}
          </p>
        </div>
        <NuxtLink
          class="offer-card__link"
          :to="card.url"
          :target="getUrlTarget(card.url)"
        >
          {{ card.buttonLabel }}
        </NuxtLink>
      </div>
      <img
        class="offer-card__img"
        :src="normalizeStrapiUrl(card.overlayImage.url)"
        :alt="card.overlayImage.name"
      />
    </div>
  </div>
</template>

<script setup>
import { normalizeStrapiUrl } from "~/utils/normalize";

const props = defineProps({
  card: { type: Object, required: true },
});

const getUrlTarget = (url) => {
  return /^https?:\/\//.test(url) ? "_blank" : "_self";
};
</script>

<style lang="scss" scoped>
.offer-card {
  --title-color: white;
  --description-color: white;
  --link-color: white;
  --link-border-color: transparent;
  --link-bg: transparent;
  --bg: none;

  height: 100%;

  position: relative;
  z-index: 10;

  background-color: var(--color-ink-base);
  background-image: var(--bg);
  background-repeat: no-repeat;
  background-size: cover;

  border-radius: 16px;

  &__wrp {
    height: 100%;

    padding: 16px 16px 24px;

    @include bigMobile {
      padding: 8px;
    }
  }

  &__content {
    height: 100%;

    position: relative;
    z-index: 5;

    @include flex-container(column, space-between, flex-start);

    gap: 16px;
  }

  &__txt-wrp {
    max-width: 205px;
    @include flex-container(column);

    gap: 8px;
  }

  &__title {
    @include font(32, 40, 700);
    color: var(--title-color);

    @include bigMobile {
      @include font(20, 26, 700);
    }
  }

  &__description {
    @include font();
    color: var(--description-color);
  }

  &__link {
    @include font(16, 20);
    color: var(--link-color);

    border-radius: 30px;
    border: 1px solid var(--link-border-color);

    background-color: var(--link-bg);

    box-shadow: 0 0 4px #00000066;

    padding: 8px 24px;
  }

  &__img {
    width: 50%;

    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
